module.exports = __webpack_public_path__ + "static/media/thumbnail.a11d98c5.jpg";